import React from 'react';
import AutocompleteMultiInput from '../../commonComponents/util/AutocompleteMultiInput';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import ValidatedPhoneInput from '../../commonComponents/util/ValidatedPhoneInput';
import Select from '../../commonComponents/util/Select';
import NumberFormat from 'react-number-format';
import RadioGroup from '../../commonComponents/util/RadioGroup';
import Toggle from '../../commonComponents/util/Toggle';
import AddressAutocomplete from '../../commonComponents/shared/AddressAutocomplete';
import SuggestionsTable from './SuggestionsTable';
import RecipientReferencesTable from '../applicationsCommon/RecipientReferencesTable';
import ApplicantPledgesTable from '../applicationsCommon/ApplicantPledgesTable';

import { isValidEmail, validateFieldLength, toTitleCase } from '../../../lib/utils';
import { RecipientTypes, Departments } from '../../../lib/systemVariables';
import { PhoneNumberTypes } from '../../../lib/constants';
import { debounce } from 'throttle-debounce';


export default class CreateRecipient extends React.Component {

    onChange = (name, value) => {
        this.setState({ [name]: value });
    }

    suggestionSelected = suggestion => {
        if (this.props.onSelectRecipientSuggestion) { //For usage with Create-Application
            this.props.onSelectRecipientSuggestion(suggestion.applicantId);
        } else {
            this.props.onChange('recipient', {
                ...this.props.recipient,
                isIsraeli: suggestion.isIsraeli,
                id: suggestion.applicantId,
                displayName: suggestion.name,
                addressDisplay: suggestion.address,
                phoneNumber: suggestion.phoneNumber.length ? suggestion.phoneNumber[0] : '',
                secondPhoneNumber: suggestion.phoneNumber.length > 1 ? suggestion.phoneNumber[1] : '',
                address: suggestion.address,
                incomplete: suggestion.incomplete
            });
        }

        this.props.suggestions.clearSuggestions();
    }

    validateEmail = (name, value) => {
        const isValid = isValidEmail(value);
        this.props.updateDataErrors(name, !isValid);
        return isValid;
    }

    validateLength = (name, length, value) => {
        const isValid = validateFieldLength(length, value);
        this.props.updateDataErrors(name, !isValid);
        return isValid;
    }

    updateApplicantType = (name, value) => {
        if (value === RecipientTypes.Organization) {
            this.props.onChange('recipient', {
                ...this.props.recipient,
                personTitleId: null,
                firstName: '',
                lastName: '',
                tags: [],
                [name]: value
            });
        } else if (value === RecipientTypes.Individual) {
            this.props.onChange('recipient', {
                ...this.props.recipient,
                teudatZehut: '',
                organization: { institutionTitleId: null, name: '', registered: true, taxId: '' },
                tags: [],
                [name]: value
            });
        }

        this.props.suggestions.clearSuggestions();
    }

    updateIsIsraeli = (name, value) => {
        if (value) {
            this.props.onChange('recipient', {
                ...this.props.recipient,
                personTitleId: null,
                address: {},
                previousAddress: {},
                organization: {
                    ...this.props.recipient.organization,
                    institutionTitleId: null
                },
                [name]: value
            });
        } else {
            this.props.onChange('recipient', {
                ...this.props.recipient,
                personTitleId: null,
                teudatZehut: '',
                bankRoutingNumber: '',
                bankBranchNumber: '',
                bankAccountNumber: '',
                bankAccountHolder: '',
                achRoutingNumber: '',
                achAccountNumber: '',
                achAccountType: '',
                address: {},
                previousAddress: {},
                organization: {
                    ...this.props.recipient.organization,
                    institutionTitleId: null
                },
                [name]: value
            });
        }

        //update suggestions
        if ((this.props.recipient.applicantType === RecipientTypes.Individual
            ? (this.props.recipient.firstName && this.props.recipient.lastName) : this.props.recipient.organization.name)
            && this.props.suggestions.getSuggestions) {
            this.props.suggestions.getSuggestions(this.props.recipient.applicantType === RecipientTypes.Individual
                ? `${this.props.recipient.firstName} ${this.props.recipient.lastName}`
                : this.props.recipient.organization.name,
                {
                    address: this.props.recipient.address,
                    phoneNumber: this.props.recipient.phoneNumber,
                    email: this.props.recipient.email,
                    applicantType: this.props.recipient.applicantType, departments: value ? Departments.IL : Departments.US
                });
        } else {
            this.props.suggestions.clearSuggestions();
        }
    }

    updateRecipient = (name, value) => {
        if (name === "firstName" || name === "lastName" || name === "reportName") value = toTitleCase(value);

        let recipient = { ...this.props.recipient, [name]: value };
        this.props.onChange('recipient', recipient);

        let recipientInfo = { address: this.props.recipient.address, phoneNumber: this.props.recipient.phoneNumber, email: this.props.recipient.email, applicantType: this.props.recipient.applicantType };
        let recipName = recipient.applicantType === RecipientTypes.Individual ? `${recipient.firstName} ${recipient.lastName}` : recipient.organization.name;
        const hasName = recipient.applicantType === RecipientTypes.Individual ? (recipient.firstName && recipient.lastName) : recipient.organization.name;
        switch (name) {
            case "firstName":
                if (value && this.props.recipient.lastName) this.getRecipientSuggestions(`${value} ${this.props.recipient.lastName}`, recipientInfo);
                else this.props.suggestions.clearSuggestions();
                return;
            case "lastName":
                if (value && this.props.recipient.firstName) this.getRecipientSuggestions(`${this.props.recipient.firstName} ${value}`, recipientInfo);
                else this.props.suggestions.clearSuggestions();
                return;
            case "email":
                if (hasName) this.getRecipientSuggestions(recipName, { ...recipientInfo, [name]: value });
                return;
            case "phoneNumber":
                if (hasName) this.getRecipientSuggestions(recipName, { ...recipientInfo, [name]: value });
                return;
            case "address":
                if (hasName) this.getRecipientSuggestions(recipName, { ...recipientInfo, [name]: value });
                return;
            default:
                return;
        }
    }

    updateOrganization = (name, val) => {
        if (name === "name") val = toTitleCase(val);

        this.props.onChange('recipient', {
            ...this.props.recipient,
            organization: {
                ...this.props.recipient.organization,
                [name]: val
            }
        });

        if (name === 'name' && val)
            this.getRecipientSuggestions(val, {
                address: this.props.recipient.address,
                phoneNumber: this.props.recipient.phoneNumber,
                email: this.props.recipient.email,
                applicantType: RecipientTypes.Organization
            });
        else if (name === 'name' && !val)
            this.props.suggestions.clearSuggestions();
    }

    updateNotRegistered = e => {
        let recipient = { ...this.props.recipient };
        recipient.organization[e.target.name] = !e.target.checked;
        if (e.target.checked)
            recipient.organization.taxId = '';

        this.props.onChange('recipient', recipient);
    }

    getRecipientSuggestions = debounce(500, async (name, otherInfo) => {
        if (this.props.suggestions.getSuggestions)
            await this.props.suggestions.getSuggestions(name, {
                ...otherInfo,
                departments: this.props.recipient.isIsraeli ? [Departments.IL] : [Departments.US]
            });
    });

    render() {
        const { recipient, campaignTagId, allowIncomplete,
            hideRecipientTitle, showPrevAddress, showSecondPhone, showEmail, setTrustedPayee,
            dataErrors, submitAttempted, suggestions, tags, departments, isManualPayment} = this.props;
        const { 
            bankRoutingNumber, 
            bankBranchNumber, 
            bankAccountNumber, 
            bankAccountHolder, 
            achRoutingNumber, 
            achAccountNumber, 
            achAccountType } = recipient.bankAccounts.filter(acct => acct.active)[0] || {};
        const inactiveBankAccounts = recipient.bankAccounts.filter(acct => !acct.active);
        return (
            <div className="recipient-info">
                {!hideRecipientTitle && <h5 className="section-header">Recipient Info</h5>}
                {!!recipient.id &&
                    <div>
                        <p className="recipient-name">{recipient.displayName}
                            {recipient.incomplete && <span className="tag incomplete">Incomplete</span>}</p>
                        <div className="recipient-details">
                            {recipient.reportName && <div>
                                <p className="small-text">
                                    <span className="accent-text">Report Name: </span>
                                    {recipient.reportName}
                                </p>
                                <br />
                            </div>}
                            <div className="flex-center">
                                {recipient.phoneNumber &&
                                    <p style={{ marginRight: "8px" }}><i className="icon ion-ios-telephone-outline accent-text2" />{recipient.phoneNumber}</p>}
                                {recipient.secondPhoneNumber &&
                                    <p><i className="icon ion-ios-telephone-outline accent-text2" />{recipient.secondPhoneNumber}</p>}
                            </div>
                            <div className="flex-center">
                            {recipient.addressDisplay &&
                                <p><i className="icon ion-ios-home-outline accent-text2" />{recipient.addressDisplay}</p>}
                            {recipient.trustedPayee && recipient.trustedPayee.referenceId &&
                                <p><i className="icons ion-ios-person-outline accent-text2" />Trusted Payee: {recipient.trustedPayee.displayName}</p>}
                            </div>
                            {recipient.bankAccounts.length > 0 && recipient.isIsraeli &&
                            <div>
                                <label className="input-label">Account Information:</label>
                                <div className="application-details-account-info flex-center">
                                    {bankRoutingNumber && <p className="small-text">
                                        <i className="icons icon-wallet accent-text2"></i>
                                        Bank Routing #: {bankRoutingNumber}
                                    </p>}
                                    {bankBranchNumber && <p className="small-text">
                                        <i className="icons icon-pie-chart accent-text2"></i>
                                        Branch #: {bankBranchNumber}
                                    </p>}
                                    {bankAccountNumber && <p className="small-text">
                                        <i className="icons icon-calculator accent-text2"></i>
                                        Account #: {bankAccountNumber}
                                    </p>}
                                    {bankAccountHolder && <p className="small-text">
                                        <i className="material-icons accent-text2">person_outline</i>
                                        Account Holder: {bankAccountHolder}
                                    </p>}
                                    {inactiveBankAccounts.length > 0
                                        && <span className="link-text small-text" onClick={() => this.setState({ showInactiveBankAccounts: true })}>See Inactive Accounts</span>}
                                </div>
                            </div>}
                            {recipient.bankAccounts.length > 0 && !recipient.isIsraeli &&
                            <div>
                                <label className="input-label">ACH Account Information:</label>
                                <div className="application-details-account-info flex-center">
                                    {achRoutingNumber && <p className="small-text">
                                        <i className="icons icon-wallet accent-text2"></i>
                                        ACH Routing #: {achRoutingNumber}
                                    </p>}
                                    {achAccountNumber && <p className="small-text">
                                        <i className="icons icon-pie-chart accent-text2"></i>
                                        ACH Account #: {achAccountNumber}
                                    </p>}
                                    {achAccountType && <p className="small-text">
                                        <i className="material-icons accent-text2">person_outline</i>
                                        Account Type: {achAccountType}
                                    </p>}
                                    {inactiveBankAccounts.length > 0
                                        && <span className="link-text small-text" onClick={() => this.setState({ showInactiveBankAccounts: true })}>See Inactive Accounts</span>}
                                </div>
                            </div>}
                                
                            {recipient.solicitors.length > 0 && <div className="mt-16">
                                <label className="input-label">Solicitors:</label>
                                {recipient.solicitors.map(reference => <div key={reference.referenceId}
                                    className="application-details-personal-info flex-center">
                                    {reference.displayName && <p className="small-text">
                                        <i className="icons ion-ios-person-outline accent-text2" />
                                        {reference.displayName}
                                    </p>}
                                    {reference.relationship && <p className="small-text">
                                        <i className="icons ion-ios-information-outline accent-text2" />
                                        {reference.relationship}
                                    </p>}
                                    {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                                        <i className="icons ion-ios-telephone-outline accent-text2" />
                                        {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                                    </p>}
                                    {reference.email && <p className="small-text">
                                        <i className="icons ion-ios-email-outline accent-text2" />
                                        {reference.email}
                                    </p>}
                                    {reference.addressDisplay && <p className="small-text">
                                        <i className="icons ion-ios-location-outline accent-text2" />
                                        {reference.addressDisplay}
                                    </p>}
                                </div>)}
                            </div>}
                        </div>
                    </div>}

                {!recipient.id &&
                    <div>
                        {tags.recipientTypes.length > 1 &&
                            <RadioGroup
                                options={tags.recipientTypes}
                                title="Recipient Type"
                                name="applicantType"
                                value={recipient.applicantType}
                                onChange={this.updateApplicantType} />}
                        {recipient.applicantType === RecipientTypes.Individual &&
                            <div className="info-row">
                                <div className="title-select">
                                    <label className="input-label">Title</label>
                                    <Select tabIndex={100}
                                        clearable={true}
                                        options={recipient.isIsraeli ? tags.israelPersonTitles : tags.usPersonTitles}
                                        label="Title" name="personTitleId"
                                        value={recipient.personTitleId || ''}
                                        onChange={e => this.updateRecipient(e.target.name, e.target.value)} />
                                </div>
                                <ValidatedInput input={<input type="text" tabIndex={110} />}
                                    label="First Name"
                                    name="firstName" value={recipient.firstName}
                                    onChange={this.updateRecipient}
                                    required={!isManualPayment && recipient.applicantType === "Individual"}
                                    showRequiredError={submitAttempted} />
                                <ValidatedInput input={<input type="text" tabIndex={120} />}
                                    label="Last Name"
                                    name="lastName" value={recipient.lastName}
                                    onChange={this.updateRecipient}
                                    required={recipient.applicantType === RecipientTypes.Individual}
                                    showRequiredError={submitAttempted} />
                                <div>
                                    <label className="input-label">Report Name</label>
                                    <input type="text" value={recipient.reportName} tabIndex={130}
                                        onChange={(e) => this.updateRecipient('reportName', e.target.value)} />
                                </div>

                                {(departments.indexOf(Departments.US) >= 0 && departments.indexOf(Departments.IL) >= 0) &&
                                    <div className="flex-center">
                                        <Toggle name="isIsraeli"
                                            value={recipient.isIsraeli}
                                            onChange={this.updateIsIsraeli} />
                                        <label className="small-text middle">Israeli</label>
                                    </div>}
                            </div>}

                        {recipient.applicantType === RecipientTypes.Organization &&
                            <div>
                                <div className="info-row">
                                    <div className="title-select">
                                        <label className="input-label">Institution Title</label>
                                        <Select tabIndex={100}
                                            clearable={true}
                                            options={recipient.isIsraeli ? tags.israelInstitutionTitles : tags.usInstitutionTitles}
                                            label="Institution Title" name="institutionTitleId"
                                            value={recipient.organization.institutionTitleId || ''}
                                            onChange={e => this.updateOrganization(e.target.name, e.target.value)} />
                                    </div>
                                    <ValidatedInput input={<input type="text" tabIndex={100} />}
                                        label="Name"
                                        name="name" value={recipient.organization.name}
                                        onChange={this.updateOrganization}
                                        required={recipient.applicantType === RecipientTypes.Organization}
                                        showRequiredError={submitAttempted} />
                                    <div>
                                        <label className="input-label">Report Name</label>
                                        <input type="text" value={recipient.reportName} tabIndex={130}
                                            onChange={(e) => this.updateRecipient('reportName', e.target.value)} />
                                    </div>
                                    {(departments.indexOf(Departments.US) >= 0 && departments.indexOf(Departments.IL) >= 0) &&
                                        <div className="flex-center">
                                            <Toggle name="isIsraeli" value={recipient.isIsraeli}
                                                onChange={this.updateIsIsraeli} />
                                            <label className="small-text middle">Israeli</label>
                                        </div>}
                                </div>
                                <div className="info-row flex-center">
                                    <div className="column-third">
                                        <ValidatedInput input={<input type="text" tabIndex={130} />}
                                            label="Email"
                                            name="email" value={recipient.email}
                                            onChange={this.updateRecipient}
                                            required={false} showRequiredError={false}
                                            validated={true} showValidationError={true}
                                            validate={this.validateEmail.bind(this, 'email')}
                                            errorMessage="Invalid Email Address" />
                                    </div>

                                    <ValidatedInput input={<NumberFormat placeholder="#########" format="#########"
                                        onValueChange={(values) => this.updateOrganization('taxId', values.value)}
                                        disabled={!recipient.organization.registered} tabIndex={140} />}
                                        label="Tax ID"
                                        name="taxId" value={recipient.organization.taxId}
                                        errorMessage="Invalid Tax ID"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'taxId', 9)}
                                        required={!isManualPayment}
                                        showRequiredError={submitAttempted && recipient.applicantType === RecipientTypes.Organization && recipient.organization.registered} />
                                    <div className="column-third">
                                        <div className="custom-check-container">
                                            <input type="checkbox" id="check" className="custom-check"
                                                name="registered"
                                                checked={!recipient.organization.registered}
                                                onChange={this.updateNotRegistered} />
                                            <label htmlFor="check">Not Registered</label>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        <div className="info-row wrap-row">
                            <AddressAutocomplete
                                tabIndex={150}
                                validateAddress={this.props.hasOwnProperty('validateAddress') ? this.props.validateAddress : undefined}
                                isIsraeli={recipient.isIsraeli}
                                showRequiredError={submitAttempted} required={!isManualPayment}
                                address={recipient.address}
                                updateAddress={this.updateRecipient.bind(this, 'address')}
                                updateError={this.props.updateDataErrors.bind(this, 'recipientAddress')}

                                addAddressLabel={!showPrevAddress
                                    ? <span onClick={() => this.props.onChange('showPrevAddress', true)}
                                        className="link-text small-text">Add Previous Address</span>
                                    : null}
                            />
                        </div>
                        {showPrevAddress && <div className="info-row wrap-row">
                            <AddressAutocomplete
                                tabIndex={190}
                                title='Previous Address'
                                isIsraeli={recipient.isIsraeli}
                                showRequiredError={submitAttempted} required={false}
                                address={recipient.previousAddress}
                                updateAddress={this.updateRecipient.bind(this, 'previousAddress')}
                                updateError={this.props.updateDataErrors.bind(this, 'recipientPreviousAddress')} />
                        </div>}
                        {recipient.isIsraeli &&
                            <div className="info-row">
                                <div className="column-quarter">
                                    <ValidatedInput input={<NumberFormat placeholder="##" format="##"
                                        onValueChange={values => this.updateRecipient('bankRoutingNumber', values.value)} tabIndex={220} />}
                                        label="Bank Number" name="bankRoutingNumber"
                                        value={recipient.bankRoutingNumber}
                                        required={!isManualPayment && recipient.isIsraeli && !recipient.trustedPayee}
                                        showRequiredError={submitAttempted}
                                        errorMessage="Invalid Bank Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'bankRoutingNumber', 2)} />
                                </div>
                                <div className="column-quarter">
                                    <ValidatedInput input={<NumberFormat placeholder="###" format="###"
                                        onValueChange={values => this.updateRecipient('bankBranchNumber', values.value)} tabIndex={230} />}
                                        label="Branch Number" name="bankBranchNumber"
                                        value={recipient.bankBranchNumber}
                                        required={!isManualPayment && recipient.isIsraeli && !recipient.trustedPayee}
                                        showRequiredError={submitAttempted}
                                        errorMessage="Invalid Branch Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'bankBranchNumber', 3)} />

                                </div>
                                <div className="column-quarter">
                                    <ValidatedInput input={<NumberFormat placeholder="###############" format="###############"
                                        onValueChange={values => this.updateRecipient('bankAccountNumber', values.value)} tabIndex={240} />}
                                        label="Account Number" name="bankAccountNumber"
                                        value={recipient.bankAccountNumber}
                                        required={!isManualPayment && recipient.isIsraeli && !recipient.trustedPayee}
                                        showRequiredError={submitAttempted} />
                                </div>
                                <div className="column-quarter">
                                    <label className="input-label">Account Holder</label>
                                    <input type="text"
                                        name="bankAccountHolder"
                                        value={recipient.bankAccountHolder || ''}
                                        onChange={e => this.updateRecipient(e.target.name, e.target.value)} />
                                </div>
                            </div>}
                            {!recipient.isIsraeli && recipient.applicantType === RecipientTypes.Organization &&
                            <div className="info-row">
                                <div className="column-quarter">
                                    <ValidatedInput input={<NumberFormat placeholder="#########" format="#########"
                                        onValueChange={values => this.updateRecipient('achRoutingNumber', values.value)} tabIndex={220} />}
                                        label="ACH Routing Number" name="achRoutingNumber"
                                        value={recipient.achRoutingNumber}
                                        showRequiredError={submitAttempted}
                                        errorMessage="Invalid ACH Routing Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'achRoutingNumber', 9)} />
                                </div>
                                <div className="column-quarter">
                                    <ValidatedInput input={<NumberFormat placeholder="##################" format="##################"
                                        onValueChange={values => this.updateRecipient('achAccountNumber', values.value)} tabIndex={230} />}
                                        label="ACH Account Number" name="achAccountNumber"
                                        value={recipient.achAccountNumber}
                                        showRequiredError={submitAttempted}
                                        errorMessage="Invalid ACH Account Number"
                                        validated={true} showValidationError={true}
                                        validate={this.validateLength.bind(this, 'achAccountNumber', 17)} />

                                </div>
                                <div className="column-quarter">
                                    <label className="input-label">Account Type</label>
                                    <ValidatedInput 
                                        input={<Select tabIndex={430} options={[{ key: 'checking', value: 'checking'}, { key: 'savings', value: 'savings'}]} />}
                                        label="" name="achAccountType" value={recipient.achAccountType || ''}
                                        onChange={e => this.updateRecipient(e.target.name, e.target.value)} 
                                    />
                                </div>
                            </div>}
                        {(suggestions.suggestions.length > 0 && (recipient.applicantType === RecipientTypes.Individual
                            ? recipient.firstName && recipient.lastName : recipient.organization.name)) &&
                            <SuggestionsTable
                                suggestions={suggestions.suggestions}
                                suggestionSelected={this.suggestionSelected}
                                allowIncomplete={allowIncomplete} />}
                        <div className="info-row wrap-row">
                            <div className="column-third modal-column-half">
                                <ValidatedPhoneInput
                                    tabIndex={250}
                                    span1={!showSecondPhone &&
                                        <span onClick={() => this.props.onChange('showSecondPhone', true)}
                                            className="link-text small-text">Add Phone</span>}
                                    span2={(!showEmail && recipient.applicantType === RecipientTypes.Individual) &&
                                        <span onClick={() => this.props.onChange('showEmail', true)}
                                            className="link-text small-text">Add Email</span>}
                                    phoneNumber={recipient.phoneNumber}
                                    phoneType={recipient.phoneType || (recipient.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American)}
                                    phoneNumberName="phoneNumber"
                                    phoneTypeName="phoneType"
                                    onChange={this.updateRecipient}
                                    error={dataErrors.phoneNumber}
                                    updateError={this.props.updateDataErrors}
                                    errorName="phoneNumber" />
                            </div>
                            {showSecondPhone && <div className="column-third">
                                <ValidatedPhoneInput
                                    tabIndex={260} label="Second Phone"
                                    phoneNumber={recipient.secondPhoneNumber}
                                    phoneType={recipient.secondPhoneType || (recipient.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American)}
                                    phoneNumberName="secondPhoneNumber"
                                    phoneTypeName="secondPhoneType"
                                    onChange={this.updateRecipient}
                                    error={dataErrors.secondPhoneNumber}
                                    updateError={this.props.updateDataErrors}
                                    errorName="secondPhoneNumber" />
                            </div>}
                            {(showEmail && recipient.applicantType === RecipientTypes.Individual) &&
                                <ValidatedInput input={<input type="text" tabIndex={270} />}
                                    label="Email"
                                    name="email" value={recipient.email}
                                    onChange={this.updateRecipient}
                                    required={false} showRequiredError={false}
                                    validated={true} showValidationError={true}
                                    validate={this.validateEmail.bind(this, 'email')}
                                    errorMessage="Invalid Email Address" />}

                            {(recipient.isIsraeli && recipient.applicantType === RecipientTypes.Individual) &&
                                <div>
                                    <ValidatedInput input={<NumberFormat placeholder="#########" format="#########" tabIndex={280}
                                        onValueChange={(values) => this.updateRecipient('teudatZehut', values.value)} />}
                                        label="Teudat Zehut" name="teudatZehut"
                                        value={recipient.teudatZehut}
                                        required={!isManualPayment && recipient.isIsraeli}
                                        showRequiredError={submitAttempted} />
                                </div>}
                        </div>
                        <div className="info-row categories-row">
                            <div>
                                <ValidatedInput input={<AutocompleteMultiInput tabIndex={290}
                                    showList={true}
                                    options={recipient.applicantType === RecipientTypes.Individual ? tags.categories.individualTags
                                        : (campaignTagId ? tags.categories.organizationTags.filter(tag => tag.key.toString() !== campaignTagId) : tags.categories.organizationTags)}
                                    selection={recipient.tags}
                                    update={this.updateRecipient} />}
                                    label="Categories"
                                    name="tags"
                                    value={recipient.tags.length}
                                    required={!isManualPayment}
                                    showRequiredError={submitAttempted} />
                                {campaignTagId && <div className="chip reverse-chip">
                                    <span>{this.props.tags.categories.organizationTags[tags.categories.organizationTags.map(t => t.key.toString()).indexOf(campaignTagId)].value}</span>
                                </div>}
                            </div>
                            <div className="column-half">
                                <label className="input-label">Note</label>
                                <textarea value={recipient.note} tabIndex={300}
                                    onChange={(e) => this.updateRecipient('note', e.target.value)} />
                            </div>
                        </div>
                        <div className="info-row references-row">
                            <RecipientReferencesTable
                                tabIndex={310}
                                references={recipient.references}
                                solicitors={recipient.solicitors}
                                roshYeshivas={recipient.roshYeshivas}
                                trustedPayee={recipient.trustedPayee}
                                updateRecipient={this.updateRecipient}
                                updateRecipientProps={props => this.props.onChange('recipient', {
                                    ...this.props.recipient,
                                    ...props
                                })}
                                setTrustedPayee={setTrustedPayee}
                                toggleSetTrustedPayee={this.props.onChange}
                                submitAttempted={submitAttempted} />
                        </div>
                       
                        <div className="info-row references-row">
                            <ApplicantPledgesTable
                                tabIndex={315}
                                applicantPledges={recipient.applicantPledges}
                                updateRecipient={this.updateRecipient}
                                updateRecipientProps={props => this.props.onChange('recipient', {
                                    ...this.props.recipient,
                                    ...props
                                })}
                                submitAttempted={submitAttempted} />
                        </div>
                    </div>}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/newApplication/CreateRecipient.jsx